import React from 'react';

export const BulletPointIcon = ({ fill='none', width='14', height='14' }) => {
  return (
    <svg 
      width={width}
      height={height} 
      viewBox="0 0 12 12" 
      fill={fill} xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3046_23054)">
        <path fillRule="evenodd" clipRule="evenodd" d="M9.5616 5.47526C9.84775 5.76143 9.84775 6.2375 9.5616 6.52367L5.52949 10.5558C5.24331 10.842 4.76725 10.8419 4.48108 10.5558L0.448986 6.52367C0.162838 6.2375 0.162838 5.76143 0.448986 5.47526L4.4811 1.44314C4.76728 1.15697 5.24331 1.15697 5.52951 1.44314L9.5616 5.47526Z" stroke="#111928" strokeWidth="0.468752" strokeMiterlimit="22.9256" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.51904 3.38441V1.44336L11.5512 5.47548C11.8373 5.76165 11.8373 6.23771 11.5512 6.52388L7.51904 10.556V8.61936" stroke="#111928" strokeWidth="0.468752" strokeMiterlimit="22.9256" strokeLinecap="round" strokeLinejoin="round"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M2.54443 6L5.00534 3.53901L7.46633 5.99991L5.00542 8.4609L2.54443 6Z" fill="#9CA3AF"/>
        </g>
        <defs>
        <clipPath id="clip0_3046_23054">
        <rect width="12" height="12" fill="white"/>
        </clipPath>
        </defs>
    </svg>
    );
};

export default BulletPointIcon;
